export function PlusIconIcon({ ...props }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8335 4.99984C10.8335 4.5396 10.4604 4.1665 10.0002 4.1665C9.53997 4.1665 9.16687 4.5396 9.16687 4.99984L9.16687 9.1665H5.0002C4.53997 9.1665 4.16687 9.5396 4.16687 9.99984C4.16687 10.4601 4.53997 10.8332 5.0002 10.8332H9.16687L9.16687 14.9998C9.16687 15.4601 9.53997 15.8332 10.0002 15.8332C10.4604 15.8332 10.8335 15.4601 10.8335 14.9998L10.8335 10.8332H15.0002C15.4604 10.8332 15.8335 10.4601 15.8335 9.99984C15.8335 9.5396 15.4604 9.1665 15.0002 9.1665H10.8335L10.8335 4.99984Z"
        fill="#262626"
      />
    </svg>
  );
}
